import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-sort',
  templateUrl: './sort.component.html',
  styleUrls: ['./sort.component.scss']
})
export class SortComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<SortComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {}
  sortData: any = [];
  selected = '';

  ngOnInit(): void {
    this.sortData = this.data.list;
    this.selected = this.data.selected;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  applySort(value: string) {
    this.dialogRef.close(value);
  }
}
